import { type InsuranceCorporateIdentity } from "../types";

export function DeutscheBankLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.457 343.384L286.071 176.757H343.55L221.929 343.384H164.457ZM94 100H414V420H94V100ZM138.772 144.793V375.136H368.945V144.793H138.772Z"
        fill="white"
      />
    </svg>
  );
}

export const DeutscheBank: InsuranceCorporateIdentity = {
  id: "deutsche-bank",
  name: "Deutsche Bank BKK",
  logo: DeutscheBankLogo,
  backgroundColor: "#000088",
  textColor: "#FFFFFF",
  wildcard: "deutsche bank",
  type: "statutory",
};
